import { RESPONSE_TYPES } from "@lib/common-interfaces";
import { observable, action } from "mobx";
import { apiGateway } from "@root/lib/http";
import { API, PARAM_KEYS } from "@lib/constants/api";

export class OrgInvitationStore {
  @observable
  public isActionPending: boolean = false;

  @observable
  public errorMessage?: string;

  constructor(
    private token: string,
    private orgName: string
  ) {}

  @action
  public accept() {
    this.doInvitationAction(API.ACCEPT_ORG_INVITATION, "accept", () => window.location.assign("/orgs/" + this.orgName));
  }

  @action
  public reject() {
    this.doInvitationAction(API.REJECT_ORG_INVITATION, "reject", () => window.location.assign("/"));
  }

  private doInvitationAction(url: string, actionName: string, onSuccess: () => void) {
    this.isActionPending = true;

    apiGateway
      .post(url, {
        params: {
          [`${PARAM_KEYS.INVITE_TOKEN}`]: this.token,
        },
        responseType: RESPONSE_TYPES.TEXT,
      })
      .then(
        action(() => {
          this.errorMessage = undefined;
          onSuccess();
        })
      )
      .catch(
        action((error) => {
          console.error(error);
          this.isActionPending = false;
          this.errorMessage = `Unable to ${actionName} the invitation`;
        })
      );
  }
}
